import { newNode } from '../DynamicAdvisorComponent/utils'
import { BrandIcon } from '@ampcore/design-system'
import React from 'react'
import { createRoot } from 'react-dom/client'

export const newProfileImage = (json = {}) => {
  json = typeof json === 'object' ? json : {}
  const src = json.image || `${window.AMPCOMPATH}images/dac-missing-image.png`
  const href = json.urls ? json.urls.site : null
  const alt = href ? 'Visit advisor website' : ''
  const img = newNode('img', {
    src,
    alt,
    className: 'Advisor-image u-maxWidth100'
  })

  if (href) {
    const target = '_blank'
    const rel = 'noopener noreferrer'
    const link = newNode('a', {
      href,
      target,
      rel,
      className: 'Link u-maxWidth100'
    })
    link.append(img)
    return link
  }
  return img
}

export const newInfoItems = (json = {}) => {
  json = typeof json === 'object' ? json : {}
  const details = ['designations', 'title', 'email', 'phone']
  const items = document.createDocumentFragment()
  const className = 'u-marginBottom2gu u-textBreak'
  const newItem = textContent => newNode('p', { textContent, className })
  const newItemContainer = info => {
    switch (info) {
    case 'phone':
      return newNode('a', { href: `tel:${json[info].replace(/\s+/g, '')}` })
    case 'email':
      return newNode('a', { href: `mailto:${json[info]}` })
    default:
      return document.createDocumentFragment()
    }
  }
  details
    .filter(info => typeof json[info] === 'string' && json[info].length)
    .forEach(info => {
      const item = newItemContainer(info)
      const data = newItem(json[info])
      item.append(data)
      items.append(item)
    })

  return items
}

const SocialIconsList = ({ social, reversed }) => {
  const socialIcons = {
    twitter: reversed ? 'social-x-white' : 'social-x',
    facebook: reversed ? 'social-facebook-white' : 'social-facebook',
    linkedin: reversed ? 'social-linkedin-white' : 'social-linkedin'
  }

  const services = Object.keys(social)

  if (!services.length) {
    return null
  }

  return (
    <ul className="u-border0 u-marginLeft0">
      {services.map(svc => (
        <li
          key={svc}
          className="u-textSizeMsrp1 u-flexJustifyCenter u-inlineBlock u-marginRight2gu"
        >
          <a
            href={social[svc]}
            target="_blank"
            rel="noopener noreferrer"
            className="Icon-link"
          >
            <BrandIcon
              icon={socialIcons[svc]}
              ariaLabel={svc}
              style={{
                width: '20px',
                height: '20px'
              }}
            />
          </a>
        </li>
      ))}
    </ul>
  )
}

export const newSocialIcons = (social = {}, reversed = true) => {
  social = typeof social === 'object' ? social : {}
  const html = document.createElement('div') // Use a div instead of a document fragment
  const root = createRoot(html)
  root.render(<SocialIconsList social={social} reversed={reversed} />)
  return html
}
